// extracted by mini-css-extract-plugin
export default {"formHeading":"YL-z","form":"ZL-z","submitBtn":"_L-z","disabled":"aM-z","input":"bM-z","error":"cM-z","submitMsg":"dM-z","signIn":"eM-z"};